// src/screens/HomeScreen.js
import React, { useState, useCallback, useEffect, useRef, useContext } from 'react';
import {
  StyleSheet,
  Text,
  View,
  FlatList,
  TouchableOpacity,
  Alert,
  ActivityIndicator,
  Vibration,
  Animated,
  Modal,
  TextInput,
} from 'react-native';
import { Dimensions } from 'react-native';
import { AuthContext } from '../context/AuthContext';
import CONFIG from '../config/Config';
import { GestureHandlerRootView, PanGestureHandler } from 'react-native-gesture-handler';
import { useAudioPlayer } from 'expo-audio';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StatusBar } from 'expo-status-bar';
import { Ionicons } from '@expo/vector-icons';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { useScanner } from '../context/ScannerContext';
//import { io } from 'socket.io-client';

import CustomAlert from '../components/CustomAlert';
import TahsilatModal from '../components/Tahsilat';
import BarkodTarayici from '../components/BarkodTarayici'; // ← YENİ
import HiddenScannerInput from '../components/HiddenScannerInput';
import ScanToast from '../components/ScanToast';

const { height: SCREEN_HEIGHT, width: SCREEN_WIDTH } = Dimensions.get('window');
//const socket = io('https://durumrapor.com', {
//  path: '/KasapSocket/socket.io', // Nginx'in yakalayacağı yol
//  transports: ['websocket'], // Polling yerine direkt websocket kullanmaya zorla
//});

export default function HomeScreen({ route }) {
  const { userToken } = useContext(AuthContext);
  const userInfo = userToken ? JSON.parse(userToken) : null;

  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cariler, setCariler] = useState([]);
  const [isCariModalOpen, setIsCariModalOpen] = useState(false);
  const [searchCari, setSearchCari] = useState('');
  const [isTahsilatOpen, setIsTahsilatOpen] = useState(false);
  const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
  const [noteText, setNoteText] = useState('');
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    title: '', message: '', type: 'info',
    confirmText: 'Tamam', cancelText: 'Vazgeç',
    showCancel: false, onConfirm: () => { }, onCancel: () => { },
  });

  const [adisyonlar, setAdisyonlar] = useState([]);
  const [aktifAdisyonIndex, setAktifAdisyonIndex] = useState(0);

  const [toast, setToast] = useState({ visible: false, message: '' });
  const showToast = (message) => setToast({ visible: true, message });
  const hideToast = () => setToast((p) => ({ ...p, visible: false }));

  const aktifAdisyon = adisyonlar[aktifAdisyonIndex];
  const basket = aktifAdisyon?.items || [];
  const sepetBos = basket.length === 0;
  const totalPrice = basket.reduce((sum, item) => sum + item.tutar, 0);

  const translateX = useRef(new Animated.Value(0)).current;
  const isFirstLoad = useRef(true);
  const player = useAudioPlayer(require('../../assets/beep.mp3'));

  // ── BT scanner: route.params üzerinden gelen barkod ────────
  const navigation = useNavigation();
  const { refocus: refocusScanner } = useScanner();

  useEffect(() => {
    if (route?.params?.pendingBarcode && route?.params?.scanTs) {
      const code = route.params.pendingBarcode;
      // Açık modal/alert varsa kapat → kullanıcı barkoda dönsün
      setIsScannerOpen(false);
      setIsCariModalOpen(false);
      setIsTahsilatOpen(false);
      setIsNoteModalOpen(false);
      setAlertVisible(false);
      // Param'ı temizle (aynı barkod tekrar tetiklenmesin)
      navigation.setParams({ pendingBarcode: undefined, scanTs: undefined });
      handleBarCodeScanned(code);
    }
  }, [route?.params?.scanTs]);

  // Modal kapanınca sink'i yeniden odakla (kullanıcı modal içindeki input'a dokunup
  // çıkmış olabilir; sonraki BT scan kaybolmasın)
  useEffect(() => {
    if (!isScannerOpen && !isCariModalOpen && !isTahsilatOpen && !isNoteModalOpen && !alertVisible) {
      refocusScanner();
    }
  }, [isScannerOpen, isCariModalOpen, isTahsilatOpen, isNoteModalOpen, alertVisible, refocusScanner]);


  // ── Socket ───────────────────────────────────────────────────
  //useEffect(() => {
  //  socket.on('connect', () => console.log('Socket sunucusuna bağlandı!'));
  //  return () => socket.off('connect');
  //}, []);

  // ── Not modalı açılınca mevcut notu getir ───────────────────
  useEffect(() => {
    if (isNoteModalOpen) {
      setNoteText(adisyonlar[aktifAdisyonIndex]?.note || '');
    }
  }, [isNoteModalOpen, aktifAdisyonIndex, adisyonlar]);

  // ── Cari değişince fiyatları yeniden hesapla ────────────────
  const currentCariID = aktifAdisyon?.musteri_cari_id;
  useEffect(() => {
    if (basket.length === 0 || !currentCariID) return;

    const updatePricesForNewCari = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${CONFIG.API_BASE_URL}/recalculate_basket_prices`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
          body: JSON.stringify({ musteri_id: currentCariID, items: basket }),
        });
        const result = JSON.parse(await response.text());

        if (result.success) {
          setAdisyonlar(prev => prev.map((adisyon, index) =>
            index === aktifAdisyonIndex ? { ...adisyon, items: result.updated_items } : adisyon
          ));

          const currentDbId = adisyonlar[aktifAdisyonIndex]?.db_id;
          if (currentDbId) {
            await fetch(`${CONFIG.API_BASE_URL}/adisyon_kaydet`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
              body: JSON.stringify({
                db_id: currentDbId,
                musteri_cari_id: currentCariID,
                items: result.updated_items,
                kasiyer: userInfo,
              }),
            });
          }
        }
      } catch (error) {
        console.error('Fiyat yeniden hesaplama hatası:', error);
      } finally {
        setLoading(false);
      }
    };

    updatePricesForNewCari();
  }, [currentCariID]);

  // ── Veri çekme ───────────────────────────────────────────────
  const fetchCariler = async () => {
    let tempText = '';
    try {
      const response = await fetch(`${CONFIG.API_BASE_URL}/cari`, { headers: { 'X-App-Env': CONFIG.ENV } });
      tempText = await response.text();
      const result = JSON.parse(tempText);
      if (result.success) setCariler(result.data);
      else console.warn('API Başarısız:', result.message);
    } catch (error) {
      Alert.alert('Hata', 'Veri çekilemedi. Detay: ' + tempText.substring(0, 100));
    }
  };

  const fetchActiveAdisyons = async (hedefDbId = null) => {
    try {
      const response = await fetch(`${CONFIG.API_BASE_URL}/get_active_adisyons`, { headers: { 'X-App-Env': CONFIG.ENV } });
      const result = await response.json();


      setAdisyonlar(prevAdisyonlar => {
        const localUnsaved = prevAdisyonlar.filter(
          a => a.db_id === null && (a.items.length > 0 || (a.note && a.note.trim() !== ''))
        );

        let combined = [...localUnsaved];

        if (result.success && result.data.length > 0) {
          const mapped = result.data.map(item => ({
            id: item.id.toString(),
            db_id: item.id,
            items: item.items || [],
            musteri_cari_id: item.musteri_id || 1,
            note: item.note || '',
            musteri_adi: item.musteri_adi || 'PERAKENDE',
          }));
          combined = [...mapped, ...localUnsaved];
        }

        const hasEmpty = combined.some(
          a => a.items.length === 0 && (!a.note || a.note === '') && a.musteri_cari_id === 1
        );
        if (!hasEmpty) {
          combined.push({ id: Date.now().toString(), items: [], db_id: null, musteri_cari_id: 1 });
        }

        // Geri çağrılan adisyona otomatik geç
        if (hedefDbId) {
          const hedefIndex = combined.findIndex(a => a.db_id === hedefDbId);
          if (hedefIndex !== -1) {
            setAktifAdisyonIndex(hedefIndex);
          }
        }


        return combined;
      });
    } catch (error) {
      console.error('Adisyonlar yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (route?.params?.refreshAdisyonlar) {
      const hedefDbId = route.params.hedefDbId || null;
      fetchActiveAdisyons(hedefDbId);
    }
  }, [route?.params?.refreshAdisyonlar]);

  useFocusEffect(useCallback(() => {
    const fetchAllData = async () => {
      if (isFirstLoad.current) setLoading(true);
      try {
        await Promise.all([fetchCariler(), fetchActiveAdisyons()]);
      } catch (err) {
        console.log('Veri yenileme hatası:', err);
      } finally {
        setLoading(false);
        isFirstLoad.current = false;
      }
    };
    fetchAllData();
    return () => { };
  }, []));

  // ── Yardımcı fonksiyonlar ────────────────────────────────────
  const formatTL = (value) =>
    new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value) + ' ₺';

  const normalizeTurkish = (text) => {
    if (!text) return '';
    return text
      .toString()
      .replace(/İ/g, 'i').replace(/I/g, 'i').replace(/ı/g, 'i')
      .replace(/Ş/g, 's').replace(/ş/g, 's')
      .replace(/Ğ/g, 'g').replace(/ğ/g, 'g')
      .replace(/Ç/g, 'c').replace(/ç/g, 'c')
      .replace(/Ö/g, 'o').replace(/ö/g, 'o')
      .replace(/Ü/g, 'u').replace(/ü/g, 'u')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  };

  const normalizePhone = (text) => {
    if (!text) return '';
    return text.toString().replace(/\D/g, '');
  };

  const showAlert = ({ title, message, type = 'info', confirmText = 'Tamam',
    cancelText = 'Vazgeç', showCancel = false, onConfirm = () => { }, onCancel = () => { } }) => {
    setAlertConfig({
      title, message, type, confirmText, cancelText, showCancel,
      onConfirm: () => { setAlertVisible(false); onConfirm(); },
      onCancel: () => { setAlertVisible(false); onCancel(); },
    });
    setAlertVisible(true);
  };

  const renderAktifCari = () => {
    const cariId = aktifAdisyon?.musteri_cari_id || 1;
    const cari = cariler.find(c => c.CariID === cariId);
    if (cari) {
      return (
        <View style={{ alignItems: 'center' }}>
          <Text style={styles.selectedCariText}>{cari.Isim}</Text>
          {cari.CariBakiye && cari.CariBakiye !== 0 ? (
            <Text style={{ color: '#E74C3C', fontSize: 13, fontWeight: 'bold', marginTop: 2 }}>
              Bakiye: {formatTL(cari.CariBakiye)}
            </Text>
          ) : null}
        </View>
      );
    }
    return (
      <View style={{ alignItems: 'center' }}>
        <Text style={styles.selectedCariText}>Parekende</Text>
      </View>
    );
  };

  // Tüm modallar açıkken gelen BT scan: hepsini kapat + barkodu işle
  const handleBarCodeScannedFromModal = (code) => {
    setIsCariModalOpen(false);
    setIsTahsilatOpen(false);
    setIsNoteModalOpen(false);
    setAlertVisible(false);
    setSearchCari('');
    handleBarCodeScanned(code);
  };

  // ── Barkod okundu — koordinat filtresi BarkodTarayici'da ────
  const handleBarCodeScanned = async (data) => {
    const currentAdisyon = adisyonlar[aktifAdisyonIndex];
    const dbId = currentAdisyon?.db_id;
    const currentBasket = currentAdisyon?.items || [];
    const cariID = currentAdisyon.musteri_cari_id;



    const mevcutIndex = currentBasket.findIndex(
      item => item.barcode_raw === data
    );

    //console.log(currentBasket);

    if (mevcutIndex !== -1) {
      const mevcutItem = currentBasket[mevcutIndex];

      const isTartili = mevcutItem.tartili === true || (
        mevcutItem.barcode_raw && (
          mevcutItem.barcode_raw.startsWith('27') ||
          mevcutItem.barcode_raw.startsWith('28') ||
          mevcutItem.barcode_raw.startsWith('29')
        )
      );

      if (isTartili) {
        // Tartılı ürünler her okutmada farklı ağırlık taşır, uyar
        Vibration.vibrate(100);
        showAlert({ title: 'Uyarı', message: 'Bu ürün zaten sepette!', type: 'warning' });
        return;
      }

      // Paketli ürün: sessizce miktarı artır
      Vibration.vibrate(100);

      const yeniBirimFiyat = mevcutItem.ozel_fiyat ?? mevcutItem.fiyat;
      const yeniMiktar = mevcutItem.miktar + 1;
      const yeniTutar = yeniBirimFiyat * yeniMiktar;

      const guncelItem = { ...mevcutItem, miktar: yeniMiktar, tutar: yeniTutar };
      // Güncellenen ürünü en üste taşı (en son etkileşim → görsel öncelik)
      const guncelListe = [guncelItem, ...currentBasket.filter((_, i) => i !== mevcutIndex)];

      setAdisyonlar(prev => {
        const yeni = [...prev];
        yeni[aktifAdisyonIndex] = { ...yeni[aktifAdisyonIndex], items: guncelListe };
        return yeni;
      });

      showToast(`${mevcutItem.ad} ×${yeniMiktar}`);
      return;
    }

    // ── TARTILI ÜRÜN VEYA YENİ PAKETLİ ÜRÜN ────────────────────
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('barkod', data);
      formData.append('MusteriID', cariID);

      const response = await fetch(`${CONFIG.API_BASE_URL}/barkod`, {
        method: 'POST',
        headers: { 'X-App-Env': CONFIG.ENV },
        body: formData,
      });
      const result = await response.json();

      if (result.success) {
        Vibration.vibrate(100);
        if (player) { player.seekTo(0); player.play(); }

        const yeniUrun = {
          ...result.urun,
          barcode_raw: data,
          id: Date.now().toString(),
        };

        const guncelListe = [yeniUrun, ...currentBasket];

        if (dbId) {
          try {
            await fetch(`${CONFIG.API_BASE_URL}/adisyon_kaydet`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
              body: JSON.stringify({
                db_id: dbId,
                musteri_cari_id: cariID,
                items: guncelListe,
                kasiyer: userInfo,
              }),
            });
          } catch (e) {
            // sunucu hatası — local liste yine güncellenecek
          }
        }

        setAdisyonlar(prev => {
          const yeni = [...prev];
          yeni[aktifAdisyonIndex] = {
            ...yeni[aktifAdisyonIndex],
            items: [yeniUrun, ...(yeni[aktifAdisyonIndex].items || [])],
          };
          return yeni;
        });

        showToast(`${yeniUrun.ad} +${yeniUrun.miktar || 1}`);
        setIsScannerOpen(false);
      } else {
        setIsScannerOpen(false);
        showAlert({ title: 'Hata', message: 'Ürün Bulunamadı', type: 'error' });
      }
    } catch (error) {
      console.error(error);
      Alert.alert('Hata', 'İşlem sırasında bir sorun oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const _adetGuncelle = async (guncelItem) => {
    const currentAdisyon = adisyonlar[aktifAdisyonIndex];
    const dbId = currentAdisyon?.db_id;

    const guncelListe = currentAdisyon.items.map(i =>
      i.id === guncelItem.id ? guncelItem : i
    );

    setAdisyonlar(prev => {
      const yeni = [...prev];
      yeni[aktifAdisyonIndex] = { ...yeni[aktifAdisyonIndex], items: guncelListe };
      return yeni;
    });

    if (dbId) {
      try {
        await fetch(`${CONFIG.API_BASE_URL}/adisyon_kaydet`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
          body: JSON.stringify({
            db_id: dbId,
            musteri_cari_id: currentAdisyon.musteri_cari_id,
            items: guncelListe,
            kasiyer: userInfo,
          }),
        });
      } catch (e) {
        console.warn('Adet sunucu hatası:', e);
      }
    }
  };

  const fisYazdir = async () => {
    // 1. Boş kontrolü
    if (!aktifAdisyon?.items?.length) {
      showAlert({ title: 'Hata', message: 'Boş Adisyon Yazdırılamaz!', type: 'error' });
      return;
    }

    // 2. Yardımcılar ve Veri Hazırlığı
    const tlFormat = (num) => Number(num).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const genelToplam = aktifAdisyon.items.reduce((acc, item) => acc + (parseFloat(item.tutar) || 0), 0);
    const cari = cariler.find(c => c.CariID === aktifAdisyon.musteri_cari_id);

    const siparisPaketi = {
      musteriAdi: cari?.Isim || 'Dükkan Satış',
      kasiyer: userInfo?.Name || 'Bilinmeyen Kasiyer',
      telefon: (cari?.Telefon || '').replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3'),
      adres: cari?.Adres || '',
      tarih: new Date().toLocaleString('tr-TR'),
      urunler: aktifAdisyon.items.map(item => ({
        ad: item.ad,
        detay: `${item.miktar} ${item.tip} X ${tlFormat(item.fiyat)} TL`,
        tutar: `${tlFormat(item.tutar)} TL`,
      })),
      toplamTutar: `${tlFormat(genelToplam)} TL`,
    };



    try {

      const response = await fetch(`${CONFIG.API_BASE_URL}/yazdir`, { // Kendi Flask URL'ni buraya yaz
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-App-Env': CONFIG.ENV,
        },
        body: JSON.stringify(siparisPaketi),
      });

      const result = await response.json();

      // 4. Yanıt Kontrolü
      if (response.ok && result.success) {
        showAlert({
          title: 'Başarılı!',
          message: 'Adisyon başarıyla yazdırıldı',
          type: 'success'
        });
      } else {
        throw new Error(result.message || 'Sunucu hatası oluştu.');
      }

    } catch (error) {
      // 5. Hata Yönetimi (Tekrar Dene Mantığı Dahil)
      showAlert({
        title: 'Eyvah!',
        message: 'Yazıcıya ulaşılamadı: ' + error.message,
        type: 'error',
        confirmText: 'Tekrar Dene',
        cancelText: 'Kapat',
        showCancel: true,
        onConfirm: () => fisYazdir(), // Hata olursa fonksiyonu tekrar tetikler
      });
    }
  };

  // ── Ürün sil ─────────────────────────────────────────────────
  const removeItem = (target) => {
    const targetId = target && typeof target === 'object' ? target.id : target;
    const currentAdisyon = adisyonlar[aktifAdisyonIndex];
    const dbId = currentAdisyon?.db_id;

    showAlert({
      title: 'Ürünü Sil',
      message: 'Bu ürünü listeden kaldırmak istiyor musunuz?',
      type: 'warning',
      confirmText: 'Sil',
      cancelText: 'İptal',
      showCancel: true,
      onConfirm: async () => {
        const itemsAfterDelete = currentAdisyon.items.filter(
          item => String(item?.id) !== String(targetId)
        );
        const adisyonBos = itemsAfterDelete.length === 0;

        if (dbId) {
          try {
            setLoading(true);
            if (adisyonBos) {
              const formData = new FormData();
              formData.append('db_id', dbId);
              await fetch(`${CONFIG.API_BASE_URL}/adisyon_sil`, { method: 'POST', headers: { 'X-App-Env': CONFIG.ENV }, body: formData });
            } else {
              await fetch(`${CONFIG.API_BASE_URL}/adisyon_kaydet`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
                body: JSON.stringify({
                  db_id: dbId,
                  musteri_cari_id: currentAdisyon.musteri_cari_id || 1,
                  items: itemsAfterDelete,
                  kasiyer: userInfo,
                }),
              });
            }
          } catch (error) {
            console.error('Bulut senkronizasyon hatası:', error);
          } finally {
            setLoading(false);
          }
        }

        setAdisyonlar(prev => {
          let yeni = [...prev];
          if (adisyonBos) {
            yeni.splice(aktifAdisyonIndex, 1);
          } else {
            yeni[aktifAdisyonIndex] = { ...yeni[aktifAdisyonIndex], items: itemsAfterDelete };
          }
          if (yeni.length === 0) {
            yeni = [{ id: Date.now().toString(), items: [], db_id: null, musteri_cari_id: 1 }];
          }
          if (aktifAdisyonIndex >= yeni.length) setAktifAdisyonIndex(yeni.length - 1);
          return yeni;
        });

        Vibration.vibrate(50);
      },
    });
  };

  // ── Adisyon kaydet ───────────────────────────────────────────
  const saveAdisyon = async () => {
    if (basket.length === 0) { Vibration.vibrate(100); return; }

    setLoading(true);
    const currentAdisyon = adisyonlar[aktifAdisyonIndex];
    console.log(basket);

    try {
      const response = await fetch(`${CONFIG.API_BASE_URL}/adisyon_kaydet`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
        body: JSON.stringify({
          db_id: currentAdisyon.db_id || null,
          musteri_cari_id: currentAdisyon.musteri_cari_id || null,
          items: basket,
          note: currentAdisyon.note || '',
          kasiyer: userInfo,
        }),
      });
      const result = await response.json();

      if (result.success) {
        setAdisyonlar(prev => {
          const yeni = [...prev];
          yeni[aktifAdisyonIndex].db_id = result.db_id;
          return yeni;
        });
        Vibration.vibrate(70);

        const bosAdisyonIndex = adisyonlar.findIndex(a => a.items.length === 0);
        if (bosAdisyonIndex === -1) {
          setAdisyonlar(prev => [
            ...prev,
            { id: Date.now().toString(), items: [], db_id: null, musteri_cari_id: 1 },
          ]);
        }
        showAlert({ title: 'Başarılı', message: 'Adisyon buluta kaydedildi.', type: 'success' });
      } else {
        Alert.alert('Hata', 'Kaydedilemedi: ' + result.message);
      }
    } catch (error) {
      console.error('Kayıt Hatası:', error);
      Alert.alert('Hata', 'Sunucuya bağlanılamadı.');
    } finally {
      setLoading(false);
    }
  };

  // ── Adisyon sil ──────────────────────────────────────────────
  const deleteCurrentAdisyon = () => {
    const currentAdisyon = adisyonlar[aktifAdisyonIndex];
    if (basket.length === 0) { Vibration.vibrate(100); return; }

    if (adisyonlar.length === 1 && currentAdisyon.items.length === 0 && !currentAdisyon.note) {
      showAlert({
        title: 'Silme İptali',
        message: 'Her zaman en az bir boş adisyon olmalıdır.',
        type: 'warning',
      });
      return;
    }

    showAlert({
      title: 'Adisyonu Sil',
      message: `Adisyon ${aktifAdisyonIndex + 1} tamamen silinecek. Emin misiniz?`,
      type: 'warning',
      confirmText: 'Evet, Sil',
      cancelText: 'Vazgeç',
      showCancel: true,
      onConfirm: async () => {
        const dbId = currentAdisyon?.db_id;
        if (dbId) {
          try {
            setLoading(true);
            const formData = new FormData();
            formData.append('db_id', dbId);
            const response = await fetch(`${CONFIG.API_BASE_URL}/adisyon_sil`, { method: 'POST', headers: { 'X-App-Env': CONFIG.ENV }, body: formData });
            const result = await response.json();
            if (!result.success) {
              showAlert({ title: 'Hata', message: 'Sunucudaki kayıt silinemedi: ' + result.message, type: 'error' });
              setLoading(false);
              return;
            }
          } catch (error) {
            showAlert({ title: 'Bağlantı Hatası', message: 'Sunucuya ulaşılamadı.', type: 'error' });
            setLoading(false);
            return;
          }
        }

        setAdisyonlar(prev => {
          const yeni = prev.filter((_, i) => i !== aktifAdisyonIndex);
          if (yeni.length === 0) {
            setAktifAdisyonIndex(0);
            return [{ id: Date.now().toString(), items: [], db_id: null, musteri_cari_id: 1 }];
          }
          if (aktifAdisyonIndex >= yeni.length) setAktifAdisyonIndex(yeni.length - 1);
          return yeni;
        });

        setLoading(false);
        Vibration.vibrate(50);
      },
    });
  };

  // ── Gesture (swipe) ──────────────────────────────────────────
  const onGestureEvent = Animated.event(
    [{ nativeEvent: { translationX: translateX } }],
    { useNativeDriver: true }
  );

  const onSwipeEnd = (event) => {
    const x = event.nativeEvent.translationX;
    const vx = event.nativeEvent.velocityX;
    const threshold = 60;

    if ((x > threshold || vx > 500) && aktifAdisyonIndex > 0) {
      Vibration.vibrate(50);
      Animated.timing(translateX, { toValue: 400, duration: 200, useNativeDriver: true }).start(() => {
        setAktifAdisyonIndex(prev => prev - 1);
        translateX.setValue(-400);
        Animated.timing(translateX, { toValue: 0, duration: 200, useNativeDriver: true }).start();
      });
    } else if ((x < -threshold || vx < -500) && aktifAdisyonIndex < adisyonlar.length - 1) {
      Vibration.vibrate(50);
      Animated.timing(translateX, { toValue: -400, duration: 200, useNativeDriver: true }).start(() => {
        setAktifAdisyonIndex(prev => prev + 1);
        translateX.setValue(400);
        Animated.timing(translateX, { toValue: 0, duration: 200, useNativeDriver: true }).start();
      });
    } else {
      Animated.spring(translateX, { toValue: 0, useNativeDriver: true }).start();
    }
  };

  // ── Nokta göstergesi ─────────────────────────────────────────
  const renderDots = () => (
    <View style={styles.dotsContainer}>
      {adisyonlar.map((_, index) => (
        <View key={index} style={[styles.dot, index === aktifAdisyonIndex && styles.activeDot]} />
      ))}
    </View>
  );

  // ── Miktar formatla ──────────────────────────────────────────
  const formatMiktar = (miktar, birim) =>
    birim === 'KG' ? Number(miktar).toFixed(3) : Number(miktar).toString();


  const tahsilatKontrolUygula = () => {
    // 1. Sepet doluluk kontrolü
    if (!aktifAdisyon?.items?.length) {
      setAlertConfig({
        title: 'Uyarı',
        message: 'Sepet boş. Önce ürün ekleyin.',
        type: 'warning',
        confirmText: 'Tamam',
        showCancel: false,
        onConfirm: () => setAlertVisible(false),
      });
      setAlertVisible(true);
      return;
    }
    console.log(aktifAdisyon)

    const mevcutMusteriId = aktifAdisyon.musteri_cari_id;

    // 2. Özel Cari Kontrolü
    const hataliUrun = aktifAdisyon.items.find(
      (item) => item.OzelCari !== null && item.OzelCari !== mevcutMusteriId
    );

    if (hataliUrun) {
      // Cariler state'inden ismi bul
      const sahipCari = cariler.find(c => c.CariID === hataliUrun.OzelCari);
      const sahipCariAdi = sahipCari ? sahipCari.Isim : `Cari #${hataliUrun.OzelCari}`;

      // CustomAlert'i yapılandır
      setAlertConfig({
        title: 'Hatalı İşlem',
        message: `"${hataliUrun.ad}" ürünü yalnızca "${sahipCariAdi}" müşterisine satılabilir.\n\nLütfen ürünü sepetten çıkarın veya doğru müşteriyi seçin.`,
        type: 'error', // CustomAlert tipine göre 'error' veya 'warning'
        confirmText: 'Tamam',
        showCancel: false,
        onConfirm: () => setAlertVisible(false),
      });
      setAlertVisible(true);
      return;
    }

    // 3. Cari ID = 6 ise yalnızca OzelCari = 6 olan ürünlere izin ver
    if (mevcutMusteriId === 6) {
      const izinsizUrun = aktifAdisyon.items.find((item) => item.OzelCari !== 6);
      if (izinsizUrun) {
        const sahipCari = cariler.find(c => c.CariID === 6);
        const sahipCariAdi = sahipCari ? sahipCari.Isim : 'Cari #6';

        setAlertConfig({
          title: 'Hatalı İşlem',
          message: `"${sahipCariAdi}" müşterisinin adisyonunda yalnızca bu müşteriye özel ürünler bulunabilir.\n\n"${izinsizUrun.ad}" ürünü sepetten çıkarılmalıdır.`,
          type: 'error',
          confirmText: 'Tamam',
          showCancel: false,
          onConfirm: () => setAlertVisible(false),
        });
        setAlertVisible(true);
        return;
      }
    }

    // Tüm kontroller geçerse tahsilat modalını aç
    setIsTahsilatOpen(true);
  };


  // ────────────────────────────────────────────────────────────
  // RENDER
  // ────────────────────────────────────────────────────────────
  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <StatusBar style="dark" backgroundColor="#ffffff" translucent={false} />
      <SafeAreaView style={styles.container} edges={['top', 'left', 'right']}>

        <ScanToast visible={toast.visible} message={toast.message} onHide={hideToast} />

        <CustomAlert
          visible={alertVisible}
          title={alertConfig.title}
          message={alertConfig.message}
          type={alertConfig.type}
          confirmText={alertConfig.confirmText}
          cancelText={alertConfig.cancelText}
          showCancel={alertConfig.showCancel}
          onConfirm={alertConfig.onConfirm}
          onCancel={alertConfig.onCancel}
          onBarkodScanned={handleBarCodeScannedFromModal}
        />

        {/* ── Barkod Tarayıcı (BarkodTarayici bileşeni) ── */}
        <BarkodTarayici
          visible={isScannerOpen}
          onClose={() => setIsScannerOpen(false)}
          onBarkodOkundu={handleBarCodeScanned}
        />


        {/* ── Ana UI ── */}
        <PanGestureHandler
          onGestureEvent={onGestureEvent}
          onEnded={onSwipeEnd}
          activeOffsetX={[-20, 20]}
          failOffsetY={[-5, 5]}
        >
          <Animated.View style={[styles.mainUI, { transform: [{ translateX }] }]}>

            {/* Başlık */}
            <View style={styles.headerContainer}>
              <TouchableOpacity style={styles.printButtonPosition} onPress={fisYazdir}>
                <View style={styles.printButtonCircle}>
                  <Ionicons name="print-outline" size={26} color="white" />
                </View>
              </TouchableOpacity>

              <TouchableOpacity style={styles.headerSelection} onPress={() => setIsCariModalOpen(true)}>
                <Text style={styles.title}>Adisyon {aktifAdisyonIndex + 1}</Text>
                {renderAktifCari()}
              </TouchableOpacity>
            </View>

            <FlatList
              style={{ flex: 1 }}
              contentContainerStyle={{ flexGrow: 1, paddingBottom: 10 }}
              data={basket}
              keyExtractor={(item, index) => (item.id || index).toString()}
              renderItem={({ item }) => {
                const hasSpecialPrice = item.ozel_fiyat != null;
                const listeTutari = (item.liste_fiyati || item.fiyat) * item.miktar;
                const isTartili = item.tartili === true || (
                  item.barcode_raw && (
                    item.barcode_raw.startsWith('27') ||
                    item.barcode_raw.startsWith('28') ||
                    item.barcode_raw.startsWith('29')
                  )
                );
                const birim = isTartili ? 'KG' : (item.tip || 'Adet');

                return (
                  <TouchableOpacity onLongPress={() => removeItem(item)}>
                    <View style={styles.basketItem}>

                      {/* Ürün adı */}
                      <View style={styles.nameRow}>
                        <Text style={styles.itemTitle}>{item.ad}</Text>
                      </View>

                      {/* Fiyat satırları */}
                      {hasSpecialPrice ? (
                        <>
                          <View style={styles.priceDataRow}>
                            <Text style={[styles.calculationText, styles.strikethrough]}>
                              {formatMiktar(item.miktar, birim)} {birim} X {formatTL(item.liste_fiyati)}
                            </Text>
                            <Text style={[styles.rowTotalText, styles.strikethrough]}>
                              {formatTL(listeTutari)}
                            </Text>
                          </View>
                          <View style={styles.priceDataRow}>
                            <Text style={styles.specialCalculationText}>
                              {formatMiktar(item.miktar, birim)} {birim} X {formatTL(item.ozel_fiyat)}
                            </Text>
                            <Text style={styles.specialTotalText}>{formatTL(item.tutar)}</Text>
                          </View>
                        </>
                      ) : (
                        <View style={styles.priceDataRow}>
                          <Text style={styles.calculationText}>
                            {formatMiktar(item.miktar, birim)} {birim} X {formatTL(item.fiyat)}
                          </Text>
                          <Text style={styles.rowTotalText}>{formatTL(item.tutar)}</Text>
                        </View>
                      )}

                      {/* +/- Adet kontrolü — sadece paketli ürünlerde */}
                      {!isTartili && (
                        <View style={styles.adetRow}>
                          <TouchableOpacity
                            style={styles.adetBtn}
                            onPress={() => {
                              const yeniMiktar = item.miktar - 1;
                              if (yeniMiktar <= 0) {
                                removeItem(item);
                                return;
                              }
                              const birimFiyat = item.ozel_fiyat ?? item.fiyat;
                              _adetGuncelle({ ...item, miktar: yeniMiktar, tutar: birimFiyat * yeniMiktar });
                            }}
                          >
                            <Ionicons name="remove" size={16} color="#E74C3C" />
                          </TouchableOpacity>

                          <Text style={styles.adetText}>{item.miktar} {birim}</Text>

                          <TouchableOpacity
                            style={styles.adetBtn}
                            onPress={() => {
                              const yeniMiktar = item.miktar + 1;
                              const birimFiyat = item.ozel_fiyat ?? item.fiyat;
                              _adetGuncelle({ ...item, miktar: yeniMiktar, tutar: birimFiyat * yeniMiktar });
                            }}
                          >
                            <Ionicons name="add" size={16} color="#27AE60" />
                          </TouchableOpacity>
                        </View>
                      )}

                    </View>
                  </TouchableOpacity>
                );
              }}
            />

            {/* Footer */}
            <View style={styles.footer}>
              {renderDots()}

              <View style={styles.footerRow}>
                <TouchableOpacity style={styles.noteContainer} onPress={() => setIsNoteModalOpen(true)}>
                  <Text style={styles.noteText}>Not</Text>
                  {adisyonlar[aktifAdisyonIndex]?.note ? (
                    <Ionicons name="pencil" size={18} color="#FF9800" style={{ marginLeft: 5 }} />
                  ) : null}
                </TouchableOpacity>
                <Text style={styles.totalText}>Toplam: {formatTL(totalPrice)}</Text>
              </View>

              <TouchableOpacity
                style={[styles.button, { backgroundColor: '#2196F3' }]}
                onPress={() => setIsScannerOpen(true)}
              >
                {userInfo && (
                  <View style={styles.kasiyerRow}>
                    <Ionicons name="person" size={10} color="rgba(255,255,255,0.7)" />
                    <Text style={styles.kasiyerText}>Kasiyer: {userInfo.Name}</Text>
                  </View>
                )}
                <Text style={[styles.btnText, { marginTop: userInfo ? 8 : 0 }]}>BARKOD OKUT</Text>
              </TouchableOpacity>

              <View style={styles.row}>
                <TouchableOpacity style={[styles.smallBtn, { backgroundColor: '#E74C3C' }]} onPress={deleteCurrentAdisyon}>
                  <Text style={styles.smallBtnText}>SİL</Text>
                </TouchableOpacity>
                <TouchableOpacity style={[styles.smallBtn, { backgroundColor: '#4CAF50' }]} onPress={saveAdisyon}>
                  <Text style={styles.smallBtnText}>KAYDET</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  disabled={sepetBos}
                  style={[styles.smallBtn, { backgroundColor: sepetBos ? '#BDBDBD' : '#FF9800' }]}
                  onPress={tahsilatKontrolUygula} // <-- Doğrudan fonksiyonu tetikliyoruz
                >
                  <Text style={styles.smallBtnText}>TAHSİLAT</Text>
                </TouchableOpacity>
              </View>
            </View>

          </Animated.View>
        </PanGestureHandler>

        {/* ── Cari Seçim Modal ── */}
        <Modal visible={isCariModalOpen} animationType="slide" transparent={false}>
          <SafeAreaView style={{ flex: 1, backgroundColor: '#fff' }}>
            <HiddenScannerInput active={isCariModalOpen} onScanned={handleBarCodeScannedFromModal} />
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>Müşteri Seçimi</Text>
              <TouchableOpacity onPress={() => setIsCariModalOpen(false)}>
                <Text style={{ color: 'red', fontWeight: 'bold' }}>KAPAT</Text>
              </TouchableOpacity>
            </View>
            <TextInput
              style={styles.searchInput}
              placeholder="Cari Ara (İsim / Telefon)..."
              value={searchCari}
              onChangeText={setSearchCari}
            />
            <FlatList
              data={cariler.filter(item => {
                const query = normalizeTurkish(searchCari);
                const phoneQuery = normalizePhone(searchCari);
                const nameText = normalizeTurkish(item.Isim);
                const phoneText = normalizePhone(item.Telefon);
                const matchesName = query.length === 0 || nameText.includes(query);
                const matchesPhone = phoneQuery.length > 0 && phoneText.includes(phoneQuery);
                return matchesName || matchesPhone;
              })}
              keyExtractor={item => item.CariID.toString()}
              renderItem={({ item }) => {
                const bakiye = item.CariBakiye || 0;
                const isAlacakli = bakiye < 0;
                const bakiyeRenk = isAlacakli ? '#4CAF50' : (bakiye > 0 ? '#E53935' : '#7f8c8d');
                const mutlakBakiye = Math.abs(bakiye);
                return (
                  <TouchableOpacity
                    style={styles.cariItem}
                    onPress={() => {
                      setAdisyonlar(prev => {
                        const yeni = [...prev];
                        yeni[aktifAdisyonIndex].musteri_cari_id = item.CariID;
                        return yeni;
                      });
                      setIsCariModalOpen(false);
                      setSearchCari('');
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text style={styles.cariName}>{item.Isim}</Text>
                      <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 4 }}>
                        <View style={{ backgroundColor: bakiyeRenk, paddingHorizontal: 6, paddingVertical: 2, borderRadius: 4, marginRight: 6 }}>
                          <Text style={{ color: '#fff', fontSize: 10, fontWeight: 'bold' }}>
                            {isAlacakli ? 'İÇERİDE' : (bakiye > 0 ? 'BORÇLU' : 'TEMİZ')}
                          </Text>
                        </View>
                        <Text style={[styles.cariBakiye, { color: bakiyeRenk, fontWeight: 'bold' }]}>
                          {formatTL(mutlakBakiye)}
                        </Text>
                      </View>
                    </View>
                    <Text style={{ color: '#ccc' }}> seç {'>'} </Text>
                  </TouchableOpacity>
                );
              }}
            />
          </SafeAreaView>
        </Modal>

        {/* ── Not Modal ── */}
        <Modal visible={isNoteModalOpen} transparent animationType="slide">
          <HiddenScannerInput active={isNoteModalOpen} onScanned={handleBarCodeScannedFromModal} />
          <View style={styles.noteModalOverlay}>
            <View style={styles.noteModalBox}>
              <Text style={styles.noteModalTitle}>Adisyona Not Ekle</Text>
              <TextInput
                style={styles.noteInput}
                placeholder="Notunuzu yazın..."
                multiline
                value={noteText}
                onChangeText={setNoteText}
              />
              <View style={styles.noteModalButtons}>
                <TouchableOpacity
                  style={[styles.smallBtn, { backgroundColor: '#E74C3C' }]}
                  onPress={() => setIsNoteModalOpen(false)}
                >
                  <Text style={styles.smallBtnText}>KAPAT</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={[styles.smallBtn, { backgroundColor: '#4CAF50' }]}
                  onPress={() => {
                    setAdisyonlar(prev => {
                      const yeni = [...prev];
                      yeni[aktifAdisyonIndex].note = noteText;
                      return yeni;
                    });
                    setIsNoteModalOpen(false);
                    if (adisyonlar[aktifAdisyonIndex]?.db_id) saveAdisyon();
                  }}
                >
                  <Text style={styles.smallBtnText}>KAYDET</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Modal>

        {/* ── Tahsilat Modal ── */}
        {isTahsilatOpen && cariler?.length > 0 && (
          <TahsilatModal
            visible={isTahsilatOpen}
            onClose={() => setIsTahsilatOpen(false)}
            aktifAdisyon={aktifAdisyon}
            cariler={cariler}
            onBarkodScanned={handleBarCodeScannedFromModal}
            onPaymentConfirm={async (odeme) => {
              try {
                const response = await fetch(`${CONFIG.API_BASE_URL}/tahsilat`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
                  body: JSON.stringify(odeme),
                });
                const result = await response.json();

                if (result.success) {
                  setAdisyonlar(prev => {
                    const yeni = prev.filter((_, i) => i !== aktifAdisyonIndex);
                    return yeni.length === 0
                      ? [{ id: Date.now().toString(), items: [], db_id: null, musteri_cari_id: 1 }]
                      : yeni;
                  });
                  setAktifAdisyonIndex(prev => (prev > 0 ? prev - 1 : 0));
                  setIsTahsilatOpen(false);
                } else {
                  alert('Tahsilat işlemi başarısız oldu: ' + (result.message || 'Bilinmeyen hata'));
                }
              } catch (error) {
                console.log('API Hata:', error);
                alert('Bağlantı hatası oluştu!');
              }
            }}
          />
        )}

        {/* ── Loading Overlay ── */}
        {loading && (
          <View style={styles.loadingOverlay} pointerEvents="auto">
            <ActivityIndicator size="large" color="#fff" />
          </View>
        )}

      </SafeAreaView>
    </GestureHandlerRootView>
  );
}

// ── Stiller ──────────────────────────────────────────────────
const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#F5F5F5' },
  mainUI: { flex: 1, paddingTop: 15, paddingHorizontal: 15 },

  // Header
  headerContainer: { width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', position: 'relative', paddingVertical: 10 },
  printButtonPosition: { position: 'absolute', left: 10, zIndex: 10, padding: 10 },
  printButtonCircle: { width: 48, height: 48, borderRadius: 24, backgroundColor: '#E74C3C', justifyContent: 'center', alignItems: 'center', shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.25, shadowRadius: 3.84, elevation: 5 },
  headerSelection: { alignItems: 'center', paddingVertical: 10, borderBottomWidth: 1, borderRadius: 8, marginBottom: 10 },
  title: { fontSize: 26, fontWeight: 'bold', color: '#333', marginBottom: 2, textAlign: 'center' },
  selectedCariText: { fontSize: 16, color: '#218608', fontWeight: '600', marginTop: 2 },
  // Dots
  dotsContainer: { flexDirection: 'row', justifyContent: 'center', marginBottom: 10 },
  dot: { width: 8, height: 8, borderRadius: 4, backgroundColor: '#ccc', marginHorizontal: 4 },
  activeDot: { backgroundColor: '#333', width: 10, height: 10 },

  // Sepet
  basketItem: { backgroundColor: '#fff', paddingVertical: 12, paddingHorizontal: 16, borderBottomWidth: 1, borderBottomColor: '#f1f2f6', marginBottom: 4 },
  nameRow: { marginBottom: 6 },
  itemTitle: { fontSize: 16, fontWeight: '800', color: '#000000', textTransform: 'uppercase' },
  priceDataRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 2 },
  calculationText: { fontSize: 14, color: '#636e72' },
  rowTotalText: { fontSize: 15, color: '#2d3436', fontWeight: '600' },
  strikethrough: { textDecorationLine: 'line-through', color: '#b2bec3', opacity: 0.8 },
  specialCalculationText: { fontSize: 14, color: '#2d3436', fontWeight: '500' },
  specialTotalText: { fontSize: 15, color: '#d35400', fontWeight: '600' },

  // Footer
  footer: { borderTopWidth: 1, borderColor: '#ddd', paddingTop: 15, paddingBottom: 10, backgroundColor: '#F5F5F5' },
  footerRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 },
  totalText: { fontSize: 28, fontWeight: 'bold', color: '#333' },
  noteContainer: { flexDirection: 'row', alignItems: 'center', padding: 8, backgroundColor: '#e2e8f0', borderRadius: 8 },
  noteText: { fontWeight: '700', color: '#2563eb' },

  // Butonlar
  button: { padding: 16, borderRadius: 12, alignItems: 'center', marginBottom: 10, width: '100%', position: 'relative' },
  btnText: { color: '#fff', fontWeight: 'bold', fontSize: 16 },
  kasiyerRow: { position: 'absolute', top: 4, left: 0, right: 0, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' },
  kasiyerText: { fontSize: 10, color: 'rgba(255,255,255,0.7)', marginLeft: 4, fontWeight: 'bold', textTransform: 'uppercase' },
  row: { flexDirection: 'row', justifyContent: 'space-between', width: '100%' },
  smallBtn: { paddingVertical: 15, borderRadius: 10, width: '32%', alignItems: 'center', justifyContent: 'center' },
  smallBtnText: { color: '#fff', fontWeight: 'bold', fontSize: 12 },

  // Modaller
  modalHeader: { flexDirection: 'row', justifyContent: 'space-between', padding: 20, alignItems: 'center', borderBottomWidth: 1, borderBottomColor: '#eee' },
  modalTitle: { fontSize: 20, fontWeight: 'bold' },
  searchInput: { backgroundColor: '#f0f0f0', padding: 15, margin: 10, borderRadius: 10, fontSize: 16 },
  cariItem: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: 20, borderBottomWidth: 1, borderBottomColor: '#f0f0f0' },
  cariName: { fontSize: 18, fontWeight: '500' },
  cariBakiye: { fontSize: 14, color: '#666' },
  noteModalOverlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.6)', justifyContent: 'center', alignItems: 'center' },
  noteModalBox: { width: '85%', backgroundColor: '#fff', borderRadius: 15, padding: 20 },
  noteModalTitle: { fontSize: 18, fontWeight: '700', marginBottom: 15 },
  noteInput: { borderWidth: 1, borderColor: '#ccc', borderRadius: 8, height: 100, padding: 10, textAlignVertical: 'top', marginBottom: 15, fontSize: 16 },
  noteModalButtons: { flexDirection: 'row', justifyContent: 'space-between' },

  // Loading
  loadingOverlay: { ...StyleSheet.absoluteFillObject, backgroundColor: 'rgba(0,0,0,0.5)', justifyContent: 'center', alignItems: 'center' },

  adetRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 8,
    gap: 12,
  },
  adetBtn: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: '#f0f0f0',
    justifyContent: 'center',
    alignItems: 'center',
  },
  adetText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#2d3436',
    minWidth: 50,
    textAlign: 'center',
  },
});